
import React, { useEffect, useState } from 'react';
import { Button } from "@/components/ui/button";
import { Dialog, DialogContent, DialogTrigger } from "@/components/ui/dialog";
import { 
  hasConsentBeenGiven, 
  acceptAllCookies, 
  acceptNecessaryCookies 
} from '@/utils/cookieConsent';
import CookieSettings from './CookieSettings';

const CookieConsent: React.FC = () => {
  const [showBanner, setShowBanner] = useState(false);
  const [showDialog, setShowDialog] = useState(false);

  useEffect(() => {
    // Check if consent has already been given
    // Small delay to avoid flash on mount
    const timer = setTimeout(() => {
      if (!hasConsentBeenGiven()) {
        setShowBanner(true);
      }
    }, 1000);

    return () => clearTimeout(timer);
  }, []);

  const handleAcceptAll = () => {
    acceptAllCookies();
    setShowBanner(false);
  };

  const handleRejectNonEssential = () => {
    acceptNecessaryCookies();
    setShowBanner(false);
  };

  const handleOpenSettings = () => {
    setShowDialog(true);
  };

  const handleCloseSettings = () => {
    setShowDialog(false);
  };

  if (!showBanner) return null;

  return (
    <>
      <div className="fixed bottom-0 left-0 right-0 bg-white shadow-lg z-50 p-4 md:p-6 border-t border-gray-200">
        <div className="container-wide flex flex-col md:flex-row md:items-center justify-between gap-4">
          <div className="flex-1">
            <h2 className="text-lg font-semibold mb-2">Cookie Consent</h2>
            <p className="text-sm text-muted-foreground">
              We use cookies to improve your experience on our site. Some are essential for the site to function, 
              while others help us analyze how the site is used.
            </p>
          </div>
          <div className="flex flex-col sm:flex-row gap-2">
            <Dialog open={showDialog} onOpenChange={setShowDialog}>
              <DialogTrigger asChild>
                <Button variant="outline" onClick={handleOpenSettings}>
                  Cookie Settings
                </Button>
              </DialogTrigger>
              <DialogContent className="sm:max-w-[500px]">
                <CookieSettings onClose={handleCloseSettings} />
              </DialogContent>
            </Dialog>
            <Button variant="outline" onClick={handleRejectNonEssential}>
              Reject Non-Essential
            </Button>
            <Button className="button-primary" onClick={handleAcceptAll}>
              Accept All
            </Button>
          </div>
        </div>
      </div>
    </>
  );
};

export default CookieConsent;
